import _toConsumableArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { FETCH_TYPE } from "../actionTypes.js";
/**
 * Requesting a fetch to begin
 */

export default function createFetch(endpoint, _ref) {
  var args = _ref.args;
  var key = endpoint.key.apply(endpoint, _toConsumableArray(args));
  var resolve = 0;
  var reject = 0;
  var promise = new Promise(function (a, b) {
    resolve = a;
    reject = b;
  });
  var meta = {
    schema: endpoint.schema,
    type: endpoint.sideEffect ? 'mutate' : 'read',
    args: args,
    key: key,
    throttle: !endpoint.sideEffect,
    options: endpoint,
    resolve: resolve,
    reject: reject,
    promise: promise,
    createdAt: new Date()
  };

  if (endpoint.update) {
    meta.update = endpoint.update;
  }

  if (endpoint.optimisticUpdate) {
    meta.optimisticResponse = endpoint.optimisticUpdate.apply(endpoint, _toConsumableArray(args));
  }

  return {
    type: FETCH_TYPE,
    payload: function payload() {
      return endpoint.apply(void 0, _toConsumableArray(args));
    },
    meta: meta,
    endpoint: endpoint
  };
}
/** Future action shape
{
  type: FETCH_TYPE,
  endpoint,
  meta: {
    args,
    createdAt,
    promise,
    resolve,
    reject,
  }
} */